// Translation strings for Natal Page
export const natalTranslations = {
  pt: {
    // Header menu
    headerAbout: 'A Sofia',
    headerBusiness: 'For Businesses',
    header360Tours: '360 Virtual Tours',
    headerAboutUs: 'About Us',

    // Welcome screen
    welcomeGreeting: (name) => `Olá, ${name || 'Viajante'}!`,
    welcomeSubtitle: 'Bem-vindo ao Natal da Sofia',
    welcomeDescription: 'A Sofia bebeu demasiado Vinho do Porto e as luzes de Natal estão todas trocadas! 🍷✨\n<br/><strong>Podes ajudá-la a descobrir a verdade?</strong>',
    startButton: 'Começar Aventura ▶',

    // Intro screen
    missionTitle: 'A Missão',
    introButton: 'Vamos a isso!',
    listen: 'Ouve com atenção...',

    // Level screen
    whichIsLie: 'Qual destas frases é MENTIRA?',

    // Wrong answer feedback
    trueStatement: 'Isto é verdade!',
    tryAgain: 'Tenta outra vez.',

    // Final screen
    missionComplete: 'Missão Cumprida!',
    shareMessage: 'Gostaste do jogo? Partilha com amigos e familiares! 🎄',
    shareInputPlaceholder: 'Nome da pessoa com quem queres partilhar...',
    shareButton: 'Partilhar 🎁',
    playAgainLink: 'Jogar de Novo',

    // Share game messages
    sharePrompt: 'Por favor, escreve o nome da pessoa primeiro!',
    shareTitle: 'O Natal da Sofia',
    shareText: (name) => `Olá ${name}! Fiz este cartão de Natal personalizado para ti. A Sofia bebeu demasiado Vinho do Porto e está a trocar tudo! Ajuda-a a descobrir a verdade! 🍷🎅`,
    shareFallbackText: 'Copia este link para partilhar: ',

    // App download CTA
    tryAppButton: 'Try GuideSofia App 📲',
  },
  en: {
    // Header menu
    headerAbout: 'About Sofia',
    headerBusiness: 'For Businesses',
    header360Tours: '360 Virtual Tours',
    headerAboutUs: 'About Us',

    // Welcome screen
    welcomeGreeting: (name) => `Hi, ${name || 'Traveler'}!`,
    welcomeSubtitle: 'Welcome to Sofia\'s Christmas',
    welcomeDescription: 'Sofia had way too much Port wine and the Christmas lights are all mixed up! 🍷✨\n<br/><strong>Can you help her discover the truth?</strong>',
    startButton: 'Start Adventure ▶',

    // Intro screen
    missionTitle: 'The Mission',
    introButton: 'Let\'s go!',
    listen: 'Listen carefully...',

    // Level screen
    whichIsLie: 'Which of these statements is a LIE?',

    // Wrong answer feedback
    trueStatement: 'That\'s true!',
    tryAgain: 'Try again.',

    // Final screen
    missionComplete: 'Mission Accomplished!',
    shareMessage: 'Did you enjoy the game? Share it with friends and family! 🎄',
    shareInputPlaceholder: 'Name of the person to share with...',
    shareButton: 'Share 🎁',
    playAgainLink: 'Play Again',

    // Share game messages
    sharePrompt: 'Please enter the person\'s name first!',
    shareTitle: 'Sofia\'s Christmas',
    shareText: (name) => `Hi ${name}! I made this personalized Christmas card for you. Sofia had way too much Port wine and everything is mixed up! Can you help her discover the truth? 🍷🎅`,
    shareFallbackText: 'Copy this link to share: ',

    // App download CTA
    downloadAppTitle: 'Ready for more adventures?',
    downloadAppText: 'Download the GuideSofia app and explore museums, cities, and landmarks with our AI audio guide.',
    downloadAppButton: 'Download App 📲',
    downloadAppWebsite: 'https://www.guidesofia.com',
  }
};

// Determine language based on experience type
export const getLanguageForExperience = (experienceName) => {
  // Use English for xmas.json
  if (experienceName === 'xmas') {
    return 'en';
  }
  // Default to Portuguese for other experiences
  return 'pt';
};

// Get translation strings for a specific language
export const getTranslations = (language) => {
  return natalTranslations[language] || natalTranslations.pt;
};
